import React from 'react'

import { Form, Col } from '_zari/core'

import * as CategoriaCrud from 'services/categoria.service'

const CategoriaFormGroup = ({ value, onChange }) => {
  const [categorias, setCategorias] = React.useState([])

  React.useEffect(() => {
    CategoriaCrud.obtenerAsSelect().then(({ data }) => setCategorias(data))
  }, [])

  return (
    <Form.Group>
      <Form.Label text='CATEGORÍA' htmlFor='select-categoria' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Form.Select value={value} onChange={onChange} id='select-categoria' name='select-categoria'>
          <option value=''>Todos</option>
          {categorias &&
            categorias.map((val, key) => (
              <option key={key} value={val._id}>
                {val.nombre}
              </option>
            ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CategoriaFormGroup)
